import { render, staticRenderFns } from "./UiNavigationButton.vue?vue&type=template&id=23f61c71"
import script from "./UiNavigationButton.vue?vue&type=script&lang=js"
export * from "./UiNavigationButton.vue?vue&type=script&lang=js"
import style0 from "./UiNavigationButton.vue?vue&type=style&index=0&id=23f61c71&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports